export default "__VITE_ASSET__7qT844X2__"